var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGreyLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    clipPath: "url(#clip0_367_2916)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 1.53125C7.32304 1.53301 5.7153 2.15169 4.52951 3.25156C3.34372 4.35142 2.67671 5.84265 2.6748 7.3981C2.6748 12.4183 8.42498 16.2097 8.67008 16.3684C8.76677 16.4312 8.88195 16.4649 9 16.4649C9.11805 16.4649 9.23323 16.4312 9.32992 16.3684C9.57502 16.2097 15.3252 12.4183 15.3252 7.3981C15.3233 5.84265 14.6563 4.35142 13.4705 3.25156C12.2847 2.15169 10.677 1.53301 9 1.53125ZM9 5.2647C9.45491 5.2647 9.89961 5.38982 10.2779 5.62424C10.6561 5.85866 10.9509 6.19185 11.125 6.58168C11.2991 6.97151 11.3446 7.40046 11.2559 7.8143C11.1671 8.22814 10.9481 8.60828 10.6264 8.90664C10.3047 9.205 9.89489 9.40819 9.44872 9.4905C9.00255 9.57282 8.54008 9.53057 8.1198 9.3691C7.69952 9.20763 7.3403 8.93419 7.08756 8.58335C6.83483 8.23252 6.69993 7.82004 6.69993 7.3981C6.69993 6.83229 6.94226 6.28965 7.3736 5.88956C7.80495 5.48947 8.38998 5.2647 9 5.2647Z",
    fill: "#1A1A1A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_367_2916"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyLocation);
export default __webpack_public_path__ + "static/media/grey-location.437e0cc1.svg";
export { ForwardRef as ReactComponent };